export default function pwaForceUpdate() {
  if (!('serviceWorker' in navigator)) return

  let refreshing = false

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })

  window.addEventListener('load', async () => {
    const registration = await navigator.serviceWorker.getRegistration()
    if (!registration) return

    registration.update()
    setInterval(() => registration.update(), 5 * 60 * 1000)
  })
}
